import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { SUPPORTED_LANGUAGES } from '../../i18n.js';
import { Student } from '../student.js';

/** Mirrors `setTeacherLanguageMutation` for a student account. */
export const setStudentLanguageMutation = registerMutation({
  operationName: 'setStudentLanguageMutation',
  type: () => Boolean,
  params: [{ name: 'language', type: () => String }],

  resolve: (language: string) => async () => {
    const sessionData = await CurrentUserInfo.getCurrentUserInfo()({ userID: 1 });

    if (!sessionData?.userID) {
      throw new Error('Nicht autorisiert: Kein User eingeloggt');
    }

    const resolvedLanguage = SUPPORTED_LANGUAGES.some(entry => entry.value === language) ? language : 'de';
    const studentCollection = await getCollection(Student);

    const result = await studentCollection.updateOne(
      { userID: sessionData.userID },
      {
        $set: {
          language: resolvedLanguage,
        },
      },
    );

    return result.matchedCount > 0;
  },
});
